import clsx from 'clsx';
import React from 'react';

type Props = {
  status: 'draft' | 'open' | 'closed';
};

export const StatusBadge = ({ status }: Props) => (
  <div
    className={clsx(
      'flex items-center justify-center h-full w-full border-main text-md'
    )}
    data-testid="invoice-status-badge"
  >
    <div
      className={clsx(
        'flex items-center justify-center h-full rounded-[50%] w-full border-main border-[1px]',
        status === 'draft' && 'border-dashed'
      )}
    >
      <span className="text-md text-main font-mono">
        {status.toUpperCase()}
      </span>
    </div>
  </div>
);
